<div class="nw-table-wrapper">
    <table class="nw-table" role="table" [class.nw-table--striped]="striped">
        @if (columns.length) {
            <colgroup>
                @for (column of columns; track trackByColumn($index, column)) {
                    <col
                        [style.width]="
                            isIcon(column)
                                ? column.width || '3rem'
                                : isTruncated(column)
                                  ? null
                                  : column.width || null
                        "
                    />
                }
                @if (showChevron) {
                    <col style="width: 3rem" />
                }
            </colgroup>
        }

        <thead class="nw-table__head">
            <tr class="nw-table__row nw-table__row--head">
                @for (column of columns; track trackByColumn($index, column)) {
                    <th
                        class="nw-table__header"
                        [class]="getAlignmentClass(column.align)"
                        [class.nw-table__cell--mobile-hidden]="isMobileHidden(column)"
                        scope="col"
                    >
                        {{ column.header }}
                    </th>
                }

                @if (showChevron) {
                    <th class="nw-table__header nw-table__cell--center" scope="col"></th>
                }
            </tr>
        </thead>

        @if (rows.length) {
            @for (group of rowGroups; track group.startIndex) {
                <tbody class="nw-table__body">
                    @if (group.label) {
                        <tr class="nw-table__row nw-table__row--group">
                            <th
                                class="nw-table__cell nw-table__group"
                                scope="rowgroup"
                                [attr.colspan]="columnCount"
                            >
                                {{ group.label }}
                            </th>
                        </tr>
                    }

                    @for (row of group.rows; track trackByRow($index, row)) {
                        <tr
                            class="nw-table__row"
                            [class.nw-table__row--striped]="
                                striped && (group.startIndex + $index) % 2 === 1
                            "
                            [attr.tabindex]="showChevron ? 0 : null"
                            (click)="onRowClick(row)"
                            (keydown.enter)="onRowClick(row)"
                            (keydown.space)="onRowClick(row); $event.preventDefault()"
                        >
                            @for (
                                column of columns;
                                track trackByColumn($index, column)
                            ) {
                                <td
                                    class="nw-table__cell"
                                    [class]="getAlignmentClass(column.align)"
                                    [class.nw-table__cell--mobile-hidden]="
                                        isMobileHidden(column)
                                    "
                                    [class.nw-table__cell--truncate]="isTruncated(column)"
                                >
                                    @if (isClickable(column)) {
                                        <button
                                            type="button"
                                            class="nw-table__cell-button"
                                            [attr.data-test]="
                                                'nw-table-cell-button-' + column.key
                                            "
                                            [attr.aria-label]="
                                                getCellAriaLabel(row, column)
                                            "
                                            (click)="onCellClick(row, column, $event)"
                                            (keydown.enter)="$event.stopPropagation()"
                                            (keydown.space)="$event.stopPropagation()"
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    cellContent;
                                                    context: { row, column }
                                                "
                                            ></ng-container>
                                        </button>
                                    } @else {
                                        <ng-container
                                            *ngTemplateOutlet="
                                                cellContent;
                                                context: { row, column }
                                            "
                                        ></ng-container>
                                    }
                                </td>
                            }

                            @if (showChevron) {
                                <td
                                    class="nw-table__cell nw-table__cell--center nw-table__chevron-cell"
                                >
                                    <nw-icon aria-hidden="true" focusable="false">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 13 22"
                                            width="100%"
                                            height="100%"
                                            preserveAspectRatio="xMidYMid meet"
                                            style="display: block"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M12.06 9.94a1.502 1.502 0 0 1 0 2.124l-9 9a1.502 1.502 0 0 1-2.124-2.123L8.876 11 .942 3.06A1.502 1.502 0 0 1 3.064.935l9 9-.005.005Z"
                                            />
                                        </svg>
                                    </nw-icon>
                                </td>
                            }
                        </tr>
                    }
                </tbody>
            }
        } @else {
            <tbody class="nw-table__body">
                <tr class="nw-table__row">
                    <td
                        class="nw-table__cell nw-table__empty"
                        [attr.colspan]="columnCount"
                    >
                        {{ emptyMessage }}
                    </td>
                </tr>
            </tbody>
        }
    </table>
</div>

<ng-template #cellContent let-row="row" let-column="column">
    @if (isIcon(column)) {
        <nw-icon
            class="nw-table__icon"
            [icon]="column.icon!"
            aria-hidden="true"
        ></nw-icon>
    } @else if (column.type === 'status') {
        <span
            class="nw-table__status"
            [class]="getStatusClass(getCellValue(row, column))"
        >
            {{ getCellValue(row, column) }}
        </span>
    } @else if (isTruncated(column)) {
        <span class="nw-table__cell-text" [attr.title]="getCellValue(row, column)">{{
            getCellValue(row, column)
        }}</span>
    } @else {
        {{ getCellValue(row, column) }}
    }
</ng-template>
